export default [
  {
    path: '/fish-categories',
    name: 'fish-categories',
    component: () => import('@/views/pages/record-catch/fish-category/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-categories',
      resource: 'record_catch',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-categories/add',
    name: 'add-fish-category',
    component: () => import('@/views/pages/record-catch/fish-category/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-categories',
      resource: 'record_catch',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-categories/modify/:id',
    name: 'modify-fish-category',
    component: () => import('@/views/pages/record-catch/fish-category/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-categories',
      resource: 'record_catch',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
